import React from "react";
import styled from "styled-components";
import {
	GridComponent,
	ColumnsDirective,
	ColumnDirective,
	Group,
	Inject,
} from "@syncfusion/ej2-react-grids";

const GridWrapper = styled.div`
	.e-group-intent {
		display: block;
	}

	.e-grouptopleftcell {
		width: 28px;
	}

	.e-groupcaption:hover,
	.e-recordpluscollapse:hover,
	.e-recordplusexpand:hover {
		cursor: pointer;
	}

	.e-recordplusexpand,
	.e-recordpluscollapse {
		width: 28px !important;
	}
`;

const DocTemplate = ({ documentName, url }) => (
	<a href={url} target="_blank" rel="noopener noreferrer">
		{documentName}
	</a>
);

const GroupCaptionTemplate = group => {
	const groupItem = group.items[0].group;
	const docsText = `document${group.count == 1 ? "" : "s"}`;
	return (
		<div style={{ pointerEvents: "none" }}>
			<b>{groupItem.displayText} </b>
			<i>
				({group.count} {docsText})
			</i>
		</div>
	);
};

class PlansGrid extends React.Component {
	constructor(props) {
		super(props);
		this.initial = true;
		this.gridRef = null;
		this.plans = props.plans;
		this.isExpandCollapseTarget = el =>
			el &&
			(el.classList.contains("e-recordpluscollapse") ||
				el.classList.contains("e-recordplusexpand"));

		this.cleanTitlesAndAriaLabels = allCaptions => {
			let currentAriaLabel;
			let tempElement = document.createElement("div");

			for (let i = 0; i < allCaptions.length; i++) {
				allCaptions[i].title = "";

				// replace html strings in aria-label with plain text
				currentAriaLabel = allCaptions[i].getAttribute("aria-label");
				tempElement.innerHTML = currentAriaLabel;
				allCaptions[i].setAttribute(
					"aria-label",
					tempElement.textContent || tempElement.innerText || ""
				);
			}
		};

		this.addTextToEmptyControlsHeader = text => {
			const expandControlsHeader = this.gridRef.element.querySelectorAll(
				"tr>th.e-grouptopleftcell"
			)[0];
			const srHeader = document.createElement("span");
			srHeader.classList.add("sr-only");
			srHeader.innerHTML = text;
			expandControlsHeader.appendChild(srHeader);
		};

		this.dataBoundHandler = () => {
			if (this.gridRef && this.initial) {
				this.gridRef.groupModule.collapseAll();
				this.initial = false;
			}

			if (this.gridRef) {
				this.addTextToEmptyControlsHeader(
					"Expand or Collapsing Group Controls"
				);

				// remove html text in caption
				const allCaptions = this.gridRef.element.getElementsByClassName(
					"e-groupcaption"
				);
				this.cleanTitlesAndAriaLabels(allCaptions);
			}

			var collapsedElements = this.gridRef.element.getElementsByClassName(
				"e-recordpluscollapse"
			);
			for (let i = 0; i < collapsedElements.length; i++) {
				collapsedElements[i].setAttribute("aria-expanded", false);
			}
		};

		this.loadHandler = () => {
			// allow clicking caption row to expand group
			this.gridRef.element.addEventListener("mousedown", e => {
				let currentTd = e.target;

				while (currentTd && currentTd.tagName == "TD") {
					currentTd = currentTd.previousSibling;
					if (this.isExpandCollapseTarget(currentTd)) {
						this.gridRef.groupModule.expandCollapseRows(currentTd);
						break;
					}
				}
			});
		};
	}

	shouldComponentUpdate() {
		return false;
	}

	render() {
		return (
			<GridWrapper>
				<GridComponent
					ref={grid => (this.gridRef = grid)}
					dataBound={this.dataBoundHandler}
					load={this.loadHandler}
					dataSource={this.plans}
					allowGrouping={true}
					selectionSettings={{
						type: "Single",
						mode: "Row",
						cellSelectionMode: "BoxWithBorder",
					}}
					groupSettings={{
						showGroupedColumn: false,
						columns: ["group.sortOrder"],
						showDropArea: false,
						captionTemplate: GroupCaptionTemplate,
					}}
					style={{
						minHeight: "80px",
						maxHeight: "400px",
						overflowY: "auto",
					}}
				>
					<ColumnsDirective>
						<ColumnDirective
							field="group.sortOrder"
							headerText="Description"
						></ColumnDirective>
						<ColumnDirective
							field="documentName"
							headerText={`Individual District Maps (${this.props.plans[0].group.groupedRowsLength} Districts)`}
							template={DocTemplate}
						></ColumnDirective>
						<ColumnDirective
							field="documentDimensions"
							headerText="Dimensions"
						></ColumnDirective>
						<ColumnDirective
							field="fileSize"
							headerText="File Size (MB)"
						></ColumnDirective>
					</ColumnsDirective>
					<Inject services={[Group]} />
				</GridComponent>
			</GridWrapper>
		);
	}
}

export default PlansGrid;
